import React from 'react';
import { Header, Footer } from '../Common';
import MenuItemShop from '../../Common/MenuItemShop/MenuItemShop';

/**
 * CLS-FI page for a header menu item (/clothing/cls-fi/shop/:menuSlug): the OPEN SHOP
 * page when the open shop is configured for the item, else the fallback listing.
 * Same behaviour as CLS-DK (school-aware prices + links). No static banner photos
 * for FI yet — the brand's uploaded menu-item images or the DS default are used.
 */
const CLSFIMenuItemShop = () => (
  <MenuItemShop
    brandSlug="clsfi"
    feSlug="cls-fi"
    dataBrand="CLS"
    HeaderComponent={Header}
    FooterComponent={Footer}
    packageDescription="Pakettiratkaisu"
    schoolAware
    packagesCaption="Säästä jopa 20 %"
    packagesTitle="Paketit"
    moreLabel="lisää"
    loadingText="Ladataan tuotteita…"
    emptyTitle="Ei tuotteita juuri nyt"
    emptyText="Valikoimaa saatetaan juuri päivittää. Jos sinulla on kysyttävää, autamme mielellämme."
    contactLabel="Ota yhteyttä"
    faqLabel="FAQ"
  />
);

export default CLSFIMenuItemShop;
